export const NavbarText = {
  key1: 'Producten',
  key2: 'Toepassingen',
  key3: 'Prijs',
  key4: 'Blog',
  key5: 'Ontwikkelaars',
  key6: 'Help & Guides',
  key7: 'Login'
}

export default NavbarText;



// WEBPACK FOOTER //
// ./src/input-text/nl/navbar.js